import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import moment from "moment";
import {
  UncontrolledTooltip
} from "reactstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import LottieLoader from "../../LottieLoader";
import lottieEmptyFile from '../../../files/animation/empty_new.json';
import lottieLoaderFile from '../../../files/animation/loading.json';
import UserName from "../../Reusable/UserName";
import { pasteValue } from "../../Reusable/OnPasteValue";
const _ = require("lodash");

function fullname(cell, row) {
  return (
    <UserName user={row} />
  );
}

function formatDate(cell, row) {
  return moment(cell).format("MMMM DD, YYYY");
}
function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}

const defaultSorted = [
  {
    dataField: "createdAt", // if dataField is not match to any column you defined, it will be ignored.
    order: "desc" // desc or asc
  }
];
const status = (cell, row) => {
  const newUser = moment(row.createdAt).isSame(new Date(), "week");
  if (!row.isActive) {
    return <label class="badge badge-gradient-danger">INACTIVE</label>;
  }
  if (newUser) {
    return <label class="badge badge-gradient-info">NEW</label>;
  } else {
    return <label class="badge badge-gradient-success">ACTIVE</label>;
  }
};
const quickActions = (cell, row, rowIndex, formatExtraData) => {
  let sendTo;
  let to = row.phone;
  if (to) {
    if (
      to.includes("+1") ||
      to.includes("+") ||
      to.includes("09") ||
      to.includes("+63")
    ) {
      sendTo = to;
    } else {
      sendTo = "+1" + to;
    }
    sendTo = "tel:" + sendTo.replace(/-/g, "");
  } else {
    sendTo = "javascript:;";
  }

  const fullname = row.fname + " " + row.lname;
  return (
    <div className="btn-group">
      <UncontrolledTooltip
        placement="bottom"
        target={"resetPassword" + row._id}
      >
        Reset Password of {fullname}
      </UncontrolledTooltip>

      <button
        type="button"
        className="btn btn-info reset-password-click"
        onClick={() => formatExtraData(fullname, row._id)}
        id={"resetPassword" + row._id}
      >
        Reset Password
      </button>
    </div>
  );
};

const MySearch = props => {
  let input;
  const handleClick = () => {
    props.onSearch(input.value);
  };
  return (
    <div>
      <div class="form-group">
        <input
          type="text"
          class="form-control input-date-filter"
          id="exampleInputName1Test"
          style={{ fontSize: "20px" }}
          placeholder="Search Name, Nickname, Email, etc..."
          ref={n => (input = n)}
          onChange={handleClick}
          onPaste={(e) => {
            e.preventDefault();
            const event = pasteValue(e)
            handleClick({ target: { value: event.target.value } });
          }}
        />
      </div>
    </div>
  );
};
const NewUser = (props, context) => {
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {"   "}Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "20",
        value: 20
      },
      {
        text: "All",
        value: props.usersGivenAccessMyReading.length
      }
    ] // A numeric array is also available. the purpose of above example is custom the text
  };

  const NoDataIndication = () => (
    <div>
      {props.loading && (
        <LottieLoader
          loadLoop={true}
          autoplayLoop={true}
          source={lottieLoaderFile}
          Lheight={150}
          Lwidth={150}
          subTitle={"Please Wait ..."}
        />
      )}
      {!props.loading && (
        <LottieLoader
          loadLoop={false}
          autoplayLoop={true}
          source={lottieEmptyFile}
          Lheight={170}
          Lwidth={170}
          subTitleSmall={"Sorry! No patient found :("}
          subTitleExtraSmall={"We can't find any patient."}
        />
      )}              
    </div>
  );
  return (
    <ToolkitProvider
      keyField="_id"
      data={props.usersGivenAccessMyReading}
      columns={[
        {
          dataField: "fname",
          text: "Name",
          formatter: fullname,
          sort: true,

          filterValue: (cell, row) => {
            return row.fname + " " + row.lname;
          },
          headerFormatter: priceFormatter
        },
        {
          dataField: "wala",
          text: "Status",
          sort: false,
          headerFormatter: priceFormatter,         
          formatter: status,
          headerStyle: () => {
           return { width: '5%', textAlign: 'left' };
          },
        },
        {
          dataField: "organization",
          text: "Organization",
          sort: true,
          formatter: (cell, row) => {
            return (row.organization? row.organization :"-");
          },
          headerFormatter: priceFormatter
        },
        {
          dataField: "email",
          text: "Email Address",
          sort: true,

          headerFormatter: priceFormatter
        },
        {
          dataField: "username",
          text: "Username",
          sort: true,
          headerFormatter: priceFormatter
        },

        {
          dataField: "createdAt",
          text: "Date Added",
          formatter: formatDate,
          sort: true
        },
        {
          dataField: "bday",
          text: "Quick Actions",
          formatter: quickActions,
          formatExtraData: props.toggleReset,
          sort: false,
          headerStyle: () => {
           return { width: '8%', textAlign: 'left' };
          },
        }
      ]}
      search
    >
      {toolKitProp => (
        <div>
          <div>
            <MySearch {...toolKitProp.searchProps} />
          </div>
          <div className="scrollbar-table-cls">
          <BootstrapTable
            wrapperClasses="table-responsive"
            {...toolKitProp.baseProps}
            noDataIndication={ () => <NoDataIndication /> }
            filter={filterFactory()}
            defaultSorted={defaultSorted}
            pagination={paginationFactory(options)}
          />
          </div>
        </div>
      )}
    </ToolkitProvider>
  );
};

export default NewUser;
